import React, { useEffect } from "react";
import styled from "styled-components";

const TermsContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  font-family: Arial, sans-serif;
  line-height: 1.6;
`;

const Title = styled.h1`
  text-align: center;
  margin-bottom: 20px;
  font-weight: bold;
`;

const Section = styled.div`
  margin-bottom: 20px;
`;

const SectionTitle = styled.h2`
  font-size: 1.2em;
  margin-bottom: 10px;
  font-weight: 600;
`;

const TermsAndConditions = () => {
  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);
  }, []);

  return (
    <TermsContainer>
      <Title>Terms & Conditions</Title>
      <Section>
        <SectionTitle>1. Introduction</SectionTitle>
        <p>
          Welcome to Sophie Care 26 Inc. (“Sophie Care,” “we,” “us,” or “our”). By accessing or using our
          services, including our website, mobile application, and AI-powered telephony services, you
          agree to comply with and be bound by these Terms & Conditions. If you do not agree, please do
          not use our services.
        </p>
      </Section>
      <Section>
        <SectionTitle>2. Services Provided</SectionTitle>
        <p><strong>AI-Powered Telephony Services:</strong> Sophie Care offers AI-driven phone calls designed to provide companionship and cognitive engagement for elderly individuals...</p>
        <p><strong>Call Management Features:</strong> During an active call, users have the option to:</p>
        <ul>
          <li style={{ marginLeft: "20px" }}>Reschedule Future Calls: Adjust the timing of upcoming calls directly during the conversation.</li>
          <li style={{ marginLeft: "20px" }}>Initiate Immediate Follow-Up Calls: Request an additional call immediately after the current session concludes.</li>
        </ul>
      </Section>
      <Section>
        <SectionTitle>3. User Accounts</SectionTitle>
        <p><strong>Eligibility:</strong> Users must be at least 18 years old to create an account...</p>
        <p><strong>Account Information:</strong> Users agree to provide accurate and complete information during the registration process...</p>
      </Section>
      <Section>
        <SectionTitle>4. Subscription and Payments</SectionTitle>
        <p><strong>Subscription Plans:</strong> Sophie Care offers various subscription plans...</p>
        <p><strong>Payment Processing:</strong> All payments are processed securely through our third-party payment processor...</p>
      </Section>
      <Section>
        <SectionTitle>5. Call Recordings and Data Usage</SectionTitle>
        <p><strong>Recording Consent:</strong> By using our services, you consent to the recording and transcription of calls...</p>
        <p><strong>Data Privacy:</strong> We are committed to protecting your privacy...</p>
      </Section>
      <Section>
        <SectionTitle>6. User Responsibilities</SectionTitle>
        <p><strong>Acceptable Use:</strong> Users agree not to use Sophie Care’s services for any unlawful or prohibited activities...</p>
      </Section>
      <Section>
        <SectionTitle>7. Limitation of Liability</SectionTitle>
        <p><strong>Service Availability:</strong> While we strive to maintain uninterrupted service...</p>
        <p><strong>Not a Medical Service:</strong> Sophie Care’s services are designed for companionship and engagement purposes...</p>
      </Section>
      <Section>
        <SectionTitle>8. Termination</SectionTitle>
        <p><strong>Termination by User:</strong> You may terminate your account at any time...</p>
        <p><strong>Termination by Sophie Care:</strong> We reserve the right to suspend or terminate your account...</p>
      </Section>
      <Section>
        <SectionTitle>9. Changes to Terms</SectionTitle>
        <p>Sophie Care reserves the right to modify these Terms & Conditions at any time...</p>
      </Section>
      <Section>
        <SectionTitle>10. Contact Information</SectionTitle>
        <p>For any questions or concerns regarding these Terms & Conditions, please contact us at:</p>
        <p><strong>Email:</strong> support@sophie-care.com</p>
      </Section>
    </TermsContainer>
  );
};

export default TermsAndConditions;
